import { defaultSizingAttributes } from 'data/sizing-calculator-defaults';
import { AttributeType } from 'data/types';
import { coerceCheckboxValue } from 'utils/checkbox-value';
import { isEmpty } from 'utils/helpers';
import { ActiveItemUnsavedChangesInput } from 'utils/active-item-unsaved-changes-types';

export function areAttributeValuesEqual(
  left: unknown,
  right: unknown,
  type?: AttributeType['type']
): boolean {
  if (type === 'checkbox') {
    return coerceCheckboxValue(left) === coerceCheckboxValue(right);
  }
  if (isEmpty(left) && isEmpty(right)) {
    return true;
  }
  if (left === right) {
    return true;
  }
  const leftNumber = Number(left);
  const rightNumber = Number(right);
  if (
    left !== '' &&
    right !== '' &&
    left != null &&
    right != null &&
    !Number.isNaN(leftNumber) &&
    !Number.isNaN(rightNumber) &&
    leftNumber === rightNumber
  ) {
    return true;
  }
  return false;
}

function haveAttributesChanged(
  buffer: AttributeType[],
  saved: AttributeType[] | undefined
): boolean {
  const savedAttributes = saved ?? [];
  if (buffer.length !== savedAttributes.length) {
    return true;
  }
  return buffer.some((buffered) => {
    const original = savedAttributes.find((item) => item.id === buffered.id);
    if (!original) {
      return true;
    }
    return !areAttributeValuesEqual(
      buffered.value,
      original.value,
      buffered.type
    );
  });
}

export function hasActiveItemUnsavedChanges({
  attributesBuffer,
  savedAttributes,
  sizingAttributesBuffer,
  savedSizingAttributes,
  itemNameBuffer,
  savedItemName,
  conditionedBuffer,
  savedConditioned,
  compareConditioned,
  additionalBTUsBuffer,
  savedAdditionalBTUs,
  compareAdditionalBTUs
}: ActiveItemUnsavedChangesInput): boolean {
  const sizingAttributesChanged =
    JSON.stringify(sizingAttributesBuffer) !==
    JSON.stringify(savedSizingAttributes || defaultSizingAttributes);
  const itemNameChanged = itemNameBuffer !== savedItemName;
  const conditionedChanged =
    compareConditioned &&
    (conditionedBuffer ?? false) !== (savedConditioned ?? false);
  const additionalBTUsChanged =
    compareAdditionalBTUs &&
    ((savedAdditionalBTUs?.cooling ?? 0) !==
      (additionalBTUsBuffer.cooling ?? 0) ||
      (savedAdditionalBTUs?.heating ?? 0) !==
        (additionalBTUsBuffer.heating ?? 0));

  return (
    haveAttributesChanged(attributesBuffer, savedAttributes) ||
    sizingAttributesChanged ||
    itemNameChanged ||
    conditionedChanged ||
    additionalBTUsChanged
  );
}
